var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-content',{attrs:{"title":_vm.title,"before-change":_vm.beforeChange}},[_c('b-form-group',{attrs:{"label":_vm.label,"label-align":"right"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }